import type { SolarTpoTermsDto } from "~/api/dto/solar-proposal-pricing.dto"

import { TPO_PRODUCT_TYPE_LABEL } from "../BatteryOnlyProposal/tpo-terms-copy"

/**
 * Homeowner copy for a TPO Finance Selection (a LightReach PPA or lease) on
 * the Solar presentation, its public link and the PDF. A TPO has no system
 * price, financed amount or APR, and the homeowner doesn't own the system, so
 * nothing here says otherwise.
 */

export const TPO_SECTION_EYEBROW = `Your solar agreement`

export const TPO_SECTION_HEADING = {
  ppa: `Pay only for the power`,
  lease: `One monthly payment`,
} as const

export const TPO_SECTION_HEADING_ACCENT = `no system to buy`

/** The seller's LightReach plan without current terms: nothing priced shows until an offer is chosen. */
export const TPO_TERMS_PENDING_HEADING = `LightReach terms, once an offer is chosen.`
export const TPO_TERMS_PENDING_NOTICE = `Get LightReach pricing and choose an offer to show this proposal's LightReach terms.`

export const TPO_FIRST_YEAR_PAYMENT_LABEL = `First-year monthly payment`
export const TPO_KWH_RATE_LABEL = `Price per kWh`
export const TPO_ESCALATOR_LABEL = `Annual escalator`
export const TPO_TERM_LABEL = `Term`
export const TPO_PROVIDER_LABEL = `Provided by`
export const TPO_AGREEMENT_LABEL = `Agreement`
export const TPO_PAYMENT_OUT_OF_DATE_LABEL = `Out of date`
export const TPO_PAYMENT_UNAVAILABLE_LABEL = `Payment unavailable`

const percent = new Intl.NumberFormat(`en-US`, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/** The server's escalator percent (2.99) as printed (2.99%). */
export const formatTpoEscalator = (escalatorPercent: number): string =>
  `${percent.format(escalatorPercent)}%`

export const tpoTermText = (termYears: number): string => `${termYears} years`

/** "LightReach PPA" / "LightReach lease". */
export const tpoAgreementText = (terms: SolarTpoTermsDto): string =>
  `${terms.lender} ${TPO_PRODUCT_TYPE_LABEL[terms.kind]}`
